import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { usePageSeo } from '../../utils/seo';

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqCategory {
  title: string;
  icon: string;
  items: FaqItem[];
}

const faqCategories: FaqCategory[] = [
  {
    title: 'Общие вопросы',
    icon: 'ri-question-line',
    items: [
      {
        question: 'Что такое Promokod.online?',
        answer: 'Promokod.online — это бесплатный сервис, который собирает актуальные промокоды и скидки от популярных интернет-магазинов. Мы помогаем пользователям экономить на онлайн-покупках, предоставляя проверенные коды на скидки.'
      },
      {
        question: 'Нужна ли регистрация для использования сервиса?',
        answer: 'Нет, регистрация не требуется. Все промокоды доступны бесплатно и без ограничений. Просто выберите нужный магазин, скопируйте код и используйте его при оформлении заказа.'
      },
      {
        question: 'Сервис действительно бесплатный?',
        answer: 'Да, использование Promokod.online полностью бесплатно. Мы зарабатываем на партнёрских программах с магазинами, а для пользователей все промокоды и функции сайта доступны без оплаты.'
      },
      {
        question: 'Как часто обновляются промокоды?',
        answer: 'Мы обновляем базу промокодов ежедневно. Наша команда постоянно мониторит новые акции и предложения от магазинов-партнёров, чтобы вы всегда имели доступ к актуальным и работающим кодам.'
      }
    ]
  },
  {
    title: 'Промокоды и скидки',
    icon: 'ri-ticket-line',
    items: [
      {
        question: 'Как использовать промокод?',
        answer: 'Найдите нужный магазин на нашем сайте, выберите подходящий промокод и нажмите «Скопировать код». Затем перейдите на сайт магазина, добавьте товары в корзину и при оформлении заказа вставьте скопированный код в поле «Промокод» или «Купон».'
      },
      {
        question: 'Почему промокод не работает?',
        answer: 'Причин может быть несколько: истёк срок действия кода, не выполнены условия применения (минимальная сумма заказа, определённая категория товаров), промокод предназначен только для новых пользователей, или код уже был использован ранее. Попробуйте другой промокод из нашего списка.'
      },
      {
        question: 'Можно ли использовать несколько промокодов одновременно?',
        answer: 'Обычно интернет-магазины позволяют применить только один промокод на заказ. Однако некоторые магазины разрешают комбинировать промокоды с другими акциями и распродажами. Проверяйте условия в описании каждого промокода.'
      },
      {
        question: 'Что делать, если промокод не скопировался?',
        answer: 'Если автоматическое копирование не сработало, вы можете выделить код вручную и скопировать его с помощью Ctrl+C (Cmd+C на Mac). Также убедитесь, что в вашем браузере разрешён доступ к буферу обмена.'
      },
      {
        question: 'Можно ли использовать промокоды в мобильном приложении магазина?',
        answer: 'Да, большинство промокодов работают как на сайте, так и в мобильном приложении магазина. Просто скопируйте код и вставьте его в соответствующее поле при оформлении заказа в приложении.'
      }
    ]
  },
  {
    title: 'Магазины и партнёры',
    icon: 'ri-store-2-line',
    items: [
      {
        question: 'Какие магазины представлены на сайте?',
        answer: 'На нашем сайте представлены промокоды от сотен популярных интернет-магазинов: Skyeng, Skillbox, Нетология, 100points.ru и многие другие. Мы постоянно расширяем список партнёров, добавляя новые магазины из различных категорий.'
      },
      {
        question: 'Как добавить свой магазин на сайт?',
        answer: 'Если вы владелец интернет-магазина и хотите разместить свои промокоды на нашем сайте, перейдите в раздел «Партнёрам» и заполните форму заявки. Мы рассмотрим ваше предложение и свяжемся с вами в течение 3 рабочих дней.'
      },
      {
        question: 'Вы проверяете работоспособность промокодов?',
        answer: 'Да, мы регулярно проверяем актуальность и работоспособность всех промокодов. Если код перестаёт работать, мы оперативно удаляем его из базы. Также пользователи могут сообщить о неработающем промокоде, и мы проверим его в кратчайшие сроки.'
      }
    ]
  },
  {
    title: 'Технические вопросы',
    icon: 'ri-settings-3-line',
    items: [
      {
        question: 'Сайт не загружается или работает медленно. Что делать?',
        answer: 'Попробуйте очистить кэш браузера, отключить расширения-блокировщики рекламы или использовать другой браузер. Если проблема сохраняется, напишите нам через раздел «Контакты» — мы разберёмся.'
      },
      {
        question: 'Как сообщить о неработающем промокоде?',
        answer: 'Вы можете сообщить о неработающем промокоде через форму обратной связи в разделе «Контакты». Укажите название магазина и промокод — мы проверим его и обновим информацию.'
      },
      {
        question: 'Безопасно ли использовать ваш сайт?',
        answer: 'Абсолютно безопасно. Мы не собираем персональные данные, не требуем регистрации и не запрашиваем платёжную информацию. Все промокоды применяются непосредственно на сайтах магазинов, а мы лишь предоставляем коды.'
      }
    ]
  }
];

function FaqAccordionItem({ item, isOpen, onToggle }: { item: FaqItem; isOpen: boolean; onToggle: () => void }) {
  return (
    <div
      className={`border rounded-lg transition-all duration-300 ${
        isOpen ? 'border-orange-400 bg-orange-50/40 shadow-sm' : 'border-gray-200 bg-white hover:border-gray-300'
      }`}
    >
      <button
        onClick={onToggle}
        className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer"
      >
        <span className={`text-[15px] font-semibold pr-4 transition-colors ${isOpen ? 'text-orange-700' : 'text-gray-800'}`}>
          {item.question}
        </span>
        <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 ${
          isOpen ? 'bg-orange-500 rotate-180' : 'bg-gray-100'
        }`}>
          <i className={`ri-arrow-down-s-line text-lg ${isOpen ? 'text-white' : 'text-gray-500'}`}></i>
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pb-4">
          <div className="border-t border-orange-200/60 pt-3">
            <p className="text-sm text-gray-600 leading-relaxed">
              {item.answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Faq() {
  const [openItems, setOpenItems] = useState<Record<string, boolean>>({});
  const [activeCategory, setActiveCategory] = useState(0);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleItem = (key: string) => {
    setOpenItems(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const totalQuestions = faqCategories.reduce((sum, cat) => sum + cat.items.length, 0);
  usePageSeo({
    title: 'FAQ: вопросы и ответы | Promokod.online',
    description: 'Ответы на частые вопросы о промокодах, акциях и работе Promokod.online. Как использовать код, почему предложение не сработало и где искать актуальные скидки.',
    canonicalPath: '/faq',
  });

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      <main className="flex-grow">
        {/* Hero */}
        <section className="bg-gradient-to-br from-orange-50 via-white to-blue-50 py-14">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 text-sm font-medium px-4 py-1.5 rounded-full mb-5">
              <i className="ri-question-answer-line text-base"></i>
              <span>{totalQuestions} ответов на ваши вопросы</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Часто задаваемые вопросы
            </h1>
            <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
              Здесь собраны ответы на самые популярные вопросы о работе сервиса Promokod.online, использовании промокодов и сотрудничестве с магазинами.
            </p>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="border-b border-gray-200 bg-white sticky top-0 z-10">
          <div className="max-w-4xl mx-auto px-4">
            <div className="flex overflow-x-auto gap-1 py-3 scrollbar-hide">
              {faqCategories.map((cat, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveCategory(idx)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    activeCategory === idx
                      ? 'bg-orange-500 text-white shadow-sm'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.title}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Content */}
        <section className="py-12">
          <div className="max-w-4xl mx-auto px-4">
            {/* All categories or filtered */}
            {faqCategories.map((category, catIdx) => (
              <div
                key={catIdx}
                className={`${activeCategory === catIdx ? 'block' : 'hidden'}`}
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                    <i className={`${category.icon} text-orange-600 text-xl`}></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-gray-900">{category.title}</h2>
                    <p className="text-sm text-gray-500">{category.items.length} вопросов</p>
                  </div>
                </div>

                <div className="space-y-3">
                  {category.items.map((item, itemIdx) => {
                    const key = `${catIdx}-${itemIdx}`;
                    return (
                      <FaqAccordionItem
                        key={key}
                        item={item}
                        isOpen={!!openItems[key]}
                        onToggle={() => toggleItem(key)}
                      />
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Still have questions */}
        <section className="py-14 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <div className="bg-white rounded-2xl border border-gray-200 p-8 md:p-10 flex flex-col md:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg">
                  <i className="ri-customer-service-2-line text-white text-3xl"></i>
                </div>
              </div>
              <div className="flex-grow text-center md:text-left">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Не нашли ответ на свой вопрос?
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  Свяжитесь с нами через форму обратной связи — мы ответим в течение 24 часов. Также вы можете написать нам в Telegram.
                </p>
              </div>
              <div className="flex-shrink-0 flex gap-3">
                <a
                  href="/contacts"
                  className="inline-flex items-center gap-2 bg-orange-500 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-send-line text-base"></i>
                  Написать нам
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqCategories.flatMap(cat => cat.items.map(item => ({
          "@type": "Question",
          "name": item.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": item.answer
          }
        })))
      })}} />
    </div>
  );
}
